import React from "react";

export function useStateRef(initialState) {
    const [state, setState] = React.useState(initialState);
    const ref = React.useRef(initialState);
    if (ref.current !== state) ref.current = state;
    return [state, setState, ref];
}